import Vue from 'vue'
import _debounce from 'lodash.debounce'

export default {
  namespaced: true,
  state: {
    selectedTab: 'Toate',
    selectedTabID: 'all',
    tabs: [
      { _id: 'all', label: 'Toate', cod: 'Header_4' },
      { _id: 'fav', label: 'Favorite', cod: 'Header_5' }
    ],
    items: [],
    total: 0,
    search: null,
    pagination: {
      sortBy: 'denumire-apl', // unused
      descending: true, // unused
      page: 1,
      rowsPerPage: 10
    },
    loading: false,
    service: {
      path: 'cifuri',
      mainField: 'denumire_apl'
    },
    msgTemplates: {
      resource: 'orase',
      main: 'denumire_apl'
    }
  },
  getters: {
    tabs: state => state.tabs,
    selectedTab: state => state.selectedTab,
    selectedTabID: state => state.selectedTabID,
    items: state => state.items,
    total: state => state.total,
    loading: state => state.loading,
    pagination: state => state.pagination,
    search: state => state.search
  },
  mutations: {
    clearState (state) {
      state.items = []
    },
    setSelectedTab (state, payload) {
      if (state.tabs.length && state.tabs[payload]) {
        state.selectedTab = payload
        state.selectedTabID = state.tabs[payload]._id
      }
    },
    setItems (state, payload) {
      state.items = payload
    },
    setTotal (state, payload) {
      state.total = payload
    },
    setLoading (state, payload) {
      if (!payload) {
        setTimeout(() => {
          state.loading = payload
        }, 500)
      } else {
        state.loading = payload
      }
    },
    setPagination (state, payload) {
      Vue.set(state, 'pagination', payload)
    },
    setPerPage (state, payload) {
      Vue.set(state.pagination, 'rowsPerPage', payload)
    },
    setSearch (state, payload) {
      state.search = payload
    }
  },
  actions: {
    setEventWatchers ({ commit, dispatch, rootState }) {
      rootState.services.cifuri.events.forEach(event => {
        rootState.services.cifuri.on(event, data => {
          commit('setLoading', true)
          // dispatch('fetchTabs')
          dispatch('fetchItems')
        })
      })
      rootState.services.cifuri.on('batchDeleteSuccess', data => {
        dispatch('fetchItems')
      })
      rootState.services.cifuriperioade.events.forEach(event => {
        rootState.services.cifuriperioade.on(event, data => {
          commit('setLoading', true)
          dispatch('fetchItems')
        })
      })
    },
    fetchItems: _debounce(({ state, commit, rootState, dispatch }) => {
      commit('setLoading', true)
      // USAGE: .find({query: {$complexFacet: true, $skip: 0, $limit: 10, tip_apl: 'Judet', $regex: 'bla'}})

      let skip = 0
      let query = { $complexFacet: true, $favs: state.selectedTabID === 'fav' }

      skip = state.pagination.rowsPerPage * (state.pagination.page - 1)

      query.$limit = state.pagination.rowsPerPage
      query.$skip = skip

      if (state.search && state.search.length) {
        query.$regex = state.search
      }

      query['tip_apl'] = 'Oras'

      rootState.feathers.service(state.service.path).find({ query }).then(result => {
        // dispatch('saveMessage', {
        //   user: rootState.auth.user._id,
        //   text: `Citire "${state.msgTemplates.resource}" reusita. Pagina: ${state.pagination.page}, Total: ${result.total || result.length || 0}`,
        //   timestamp: (new Date()).toLocaleDateString('ro-RO', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric' }),
        //   type: 'info'
        // }, { root: true })

        commit('setItems', result.data)
        commit('setTotal', result.total)

        const { page, ...pagination } = state.pagination
        if (page > 1 && skip > result.total) {
          pagination.page = 1
          dispatch('paginationChanged', pagination)
        }
      }).catch(err => {
        dispatch('saveMessage', {
          user: rootState.auth.user._id,
          text: `Eroare la interogare "${state.msgTemplates.resource}"... Detalii: ${err.message || err.error.message}`,
          timestamp: (new Date()).toLocaleDateString('ro-RO', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric' }),
          type: 'error'
        }, { root: true })
        commit('setLoading', false)
      }).finally(() => {
        commit('setLoading', false)
      })
    }, 1000),
    search ({ commit, dispatch }, payload) {
      commit('setSearch', payload)
      dispatch('fetchItems')
    },
    paginationChanged ({ commit, dispatch }, payload) {
      commit('setPagination', payload)
      dispatch('fetchItems')
    },
    setSelectedTab ({ state, commit, dispatch }, payload) {
      const pos = state.tabs.findIndex(tab => tab._id === payload)
      if (pos > -1) {
        commit('setItems', [])
        commit('setSelectedTab', pos)
        dispatch('fetchItems')
      }
    },

    setPerPage ({ commit, dispatch }, payload) {
      commit('setPerPage', payload)
      dispatch('fetchItems')
    }
  }
}
